import type { Epic } from 'Flux/index.js'
import { asyncScheduler, scheduled } from 'rxjs'
import { catchError, filter, mergeMap, retryWhen } from 'rxjs/operators'
import { authenticationSlice } from 'Flux/Slice/Authentication/AuthenticationSlice.js'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'

export const FetchUserIfPresentEpic: Epic = (action$, _, { AuthenticationRepository, [authenticationSlice.name]: authentication }) =>
  action$.pipe(
    filter(authentication.updateUserIfPresent.match),
    mergeMap(() =>
      AuthenticationRepository.retrieveMe().pipe(
        mergeMap((response) => scheduled([authentication.fetchUserIfPresentSuccess({ user: response })], asyncScheduler)),
        retryWhen(serverIsNotAvailable()),
        catchError((error) => {
          console.error(error)
          return scheduled([authentication.fetchUserIfPresentSuccess({ user: undefined })], asyncScheduler)
        })
      )
    )
  )
